export default {
  supplyInsuranceListByID: {
    method: 'post',
    url: '/client/supply/insurance/list/ID'
  },
  supplyInsuranceDelete: {
    method: 'delete',
    url: '/client/supply/insurance'
  },
  supplyInsuranceCreate: {
    method: 'post',
    url: '/client/supply/insurance'
  },
  supplyInsuranceUpdate: {
    method: 'put',
    url: '/client/supply/insurance'
  }
}
